import { HttpClient } from '../HttpClient'
/**
 * * Get User's Basic Info
 */
export const GetUser = async () => {
  try {
    const { data } = await HttpClient.get('api/users/current')
    return await Promise.resolve(data)
  } catch (err) {
    return Promise.reject(err)
  }
}
